import { registerCookie, registerUser } from '../../helpers';
import jwt_decode from 'jwt-decode';
import { requestLogin, requestMe } from './network';

const status = {
    error: 'error'
};

const authenticate = (email, password, setAuthenticated, setResponseStatus, setResponseMsg) => {
    requestLogin(email, password).then((response) => {
        if (response.success) {
            const expires = new Date(response.expires_in);
            registerCookie(response.token, expires);
            const token = response.token;
            requestMe().then((responseMe) => {
                if (responseMe.success) {
                    responseMe.data.role = jwt_decode(token).role;
                    registerUser(responseMe.data, expires);
                    setAuthenticated(true);
                } else {
                    setResponseStatus(status.error);
                    setResponseMsg('Usuário ou senha inválido');
                }
            });
        } else {
            setResponseStatus(status.error);
            setResponseMsg('Usuário ou senha inválido');
        }
    });
};

export { authenticate };
